import React, { useRef, useEffect, useState } from "react";
import { Typography, Box, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import Memory from "../../common/Memory/Memory";
import PropTypes from "prop-types";
import styles from "./NotableMoments.module.css";
import { apiFetch } from "../../../utils/api";
import * as Sentry from "@sentry/react";

const NotableMoments = ({ className = "", heading, creator }) => {
  const scrollRef = useRef(null);
  const [memoryData, setMemoryData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (creator && creator.trim() !== "") {
          const data = await apiFetch(
            "/memory/creator/top",
            {
              method: "POST",
              body: JSON.stringify({
                descriptor: creator,
                amount: 10,
              }),
            },
            false
          );
          setMemoryData(data);
        } else {
          const data = await apiFetch("/api/memories/top-viewed",{}, false, true);
          setMemoryData(data);
        }
      } catch (error) {
        Sentry.captureException(error);
        console.error("❌ Failed to fetch notable moments:", error);
      }
    };

    fetchData();
  }, [creator]);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 314, behavior: "smooth" });
    }
  };

  return (
    <section className={[styles.drops, className].join(" ")}>
      {Array.isArray(memoryData) && memoryData.length > 0 ? (
        <>
          <Typography className={styles.selectedNotableDro} component="h1">
            {heading}
          </Typography>

          <Box className={styles.scrollWrapper}>
            <IconButton className={styles.arrowButton} onClick={scrollLeft}>
              <ArrowBackIos />
            </IconButton>

            <Box className={styles.memoryCards} ref={scrollRef}>
              {memoryData.map((memory) => (
                <Memory
                  key={memory.id}
                  art={memory.art}
                  description={memory.description}
                  title={memory.title}
                  uuid={memory.uuid}
                  descriptor={memory.descriptor}
                  initialLikeCount={memory.initialLikeCount}
                  memoryDate={memory.memoryDate}
                  userLiked={memory.userLiked}
                  price={memory.price}
                  all={memory.all}
                  available={memory.available}
                />
              ))}
            </Box>

            <IconButton className={styles.arrowButton} onClick={scrollRight}>
              <ArrowForwardIos />
            </IconButton>
          </Box>
        </>
      ) : (
        <></>
      )}
    </section>
  );
};

NotableMoments.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
};

export default NotableMoments;